export default __webpack_public_path__ + "static/Edita_Prima_photo_bg_about_page-2733f5e0c0bdcb8302dd220e88855551.jpg";